import { useState } from "react";
import { Form, Formik } from "formik";
import { object, string } from 'yup';

import NuevoPassword from "./password/NuevoPassword";
import md5 from "js-md5";

import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { fetchApi } from "../tools";
import {
  CheckCircleIcon,
  ExclamationCircleIcon
} from "@heroicons/react/24/outline";
import WarningModal from "../components-modals/WarningModal";

const SeleccionRecuperar = ({
  handleContinuar,
  children,
  setContenido,
  mensajeycodigo = {},
  step4Recupera=false,
  estadoEnvio,
  step3Recupera,
  handleAtras,
  datosRevisionCuenta,
  setStep3Recupera,
  correoEnviado,
  codigoEnviado,
  setCorreoEnviado,
  setCodigoEnviado
}) => {
  const cookies = new Cookies();
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  
  const urlSeguridad = cookies.get("__urlSeguridad");
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });

  const [passwordEnviado, setPasswordEnviado] = useState(false);
  
  
  const [mensajeycodigomutable, setMensajeycodigomutable]=useState({})

  const initialValues = {
    correofamilia: "",
    codigo:"",
    nuevaClave:"",
    nuevaClave2:""
  };

  const validationSchema = object({
    //"correofamilia": yup.string().required('Introduce una dirección de correo electrónico o un usuario válidos')
    nuevaClave: 
    string()
    .matches(/[0-9]+/, "La contraseña debe contener al menos un número")
    .matches(/^\S*$/, "La contraseña d no debe contener espacios")
    .min(6, "Al menos debe tener 6 caracteres")
    .max(30, "No debe tener más de 30 caracteres"),
    nuevaClave2:
    string()
    .matches(/[0-9]+/, "La contraseña debe contener al menos un número")
    .matches(/^\S*$/, "La contraseña no debe contener espacios")
    .min(6, "Al menos debe tener 6 caracteres")
    .max(30, "No debe tener más de 30 caracteres"),
  });

  const sendData = async (dato) => {
    setLoading(true);
    const res = await fetchApi({
      method: "GET",
      url: url + "/utils/recuperarcuenta",
      headers,
      content: dato,
    });
    //// si hay exito, se ejecuta esto: setContenido(datodeAPI, "contraseñaStep1")
    setLoading(false);
    if (res.msg.Error === "0") {
      
      setCorreoEnviado(true);
      setContenido(res.msg, "contrasenaStep1");
    } else {
      setModal({
        show: true,
        msg: res.msg[0].Mensaje,
        ok: false,
      });
      setCorreoEnviado(false);
    }
  };

  const sendCodigo = async (dato) => {
    setLoading(true);
    const res = await fetchApi({
      method: "GET",
      url: url + "/utils/revisioncuenta",
      headers,
      content: dato,
    });
    
    setLoading(false);
    if (res.msg[0].Error === "0") {
        setCodigoEnviado(true);
      //handleContinuar('contraseñaStep2')
      setContenido(res.msg[0], "contrasenaStep2");
    } else {
      setModal({
        show: true,
        msg: "codigo incorrecto",
        ok: false,
      });
      setCodigoEnviado(false);
    }
  };

  const sendPassword = async (dato) => {
    setLoading(true);
    const res = await fetchApi({
      method: "POST",
      url: urlSeguridad + '/seguridad/restablecerpassword',
      headers,
      content: dato,
    });
    
    setLoading(false);
    if (res.msg[0].Error === 0) {
        setPasswordEnviado(true);
      //handleContinuar('contraseñaStep2')
      setModal({
        show: true,
        msg: res.msg[0].Mensaje,
        ok: true,
      });
      setContenido(res.msg[0], "contrasenaStep3");
    } else {
      setModal({
        show: true,
        msg: res.msg[0].Mensaje,
        ok: false,
      });
      setPasswordEnviado(false);
    }
  };

  const definirCampo = (campo) => {

    let correoReg  = new RegExp("^[^@]+@[^@]+.[a-zA-Z]{2,}$", "g");
    let familiaReg = new RegExp("[A-Z]{1}[0-9]{1}[0-9]{1}[-][0-9]{3}", "g");
    let usuarioReg = new RegExp(/^(?:\b\w+\b[\s\r\n]*){2}/gm);

    let isEmail = correoReg .test(campo) ? { "email"   : campo } : false;
    let isCode  = familiaReg.test(campo) ? { "codigo"  : campo } : false;
    let isUser  = (campo).match(usuarioReg) ? { "usuario" : campo  } : false;

    let datoCorrecto = isEmail || isCode || isUser;

    if ( !isEmail && !isCode && !isUser ){ // tambien si no es usuario administrativo ^(?:\b\w+\b[\s\r\n]*){2} regExp para 2 palabras separadas
      setModal({
        show: true,
        msg: "El dato ingresado no es válido",
        ok: false,
      });
    }else{
      sendData(
        {
          Email:   datoCorrecto.email ? datoCorrecto.email : "" ,
          Familia: datoCorrecto.codigo ? datoCorrecto.codigo : "",
          Usuario :datoCorrecto.usuario ? datoCorrecto.usuario : "",
        }
      )
    }
  };

  const handleClick=(values, errors)=>{
    
    if ( Object.entries(errors).length === 0 ){
      handleSubmit(values)
    }else{
      setModal({
        show: true,
        msg: "La contraseña ingresada aun no cumple con los requerimientos de seguridad necesarios, intente nuevamente",
        ok: false,
      });
    }
  }


  const handleSubmit = (values) => {

    if (!correoEnviado) {
      definirCampo(values.correofamilia);
    }
    if (correoEnviado && !codigoEnviado) {

      if (values.codigo === mensajeycodigo.Mensaje.Codigo){
        sendCodigo({
          Codigo: values.codigo,
          Email: mensajeycodigo.Mensaje.Email.trim(),
          Familia: mensajeycodigo.Mensaje.Familia.trim()
        });
        
      }else{
        setModal({
          show: true,
          msg: "El Código introducido no es el correcto",
          ok: false,
        });
      }
    }
    
    if (correoEnviado && codigoEnviado) {
      //el password no ha sido enviado
      if (values.nuevaClave !== "" && values.nuevaClave2 !== "") {
        if (values.nuevaClave === values.nuevaClave2) {
          let claveNueva = values.nuevaClave;
          sendPassword({
            Password: md5(claveNueva),
            Familia: mensajeycodigo.Familia.trim(),
            IdEmp: "SZAMORAX01", // no hay nadie logueado
            HostName: "DEV1",
            IpHost: "131.107.1.239",
            NombreBrowser: "Windows / Chrome 10",
          });
        } else {
          setModal({
            show: true,
            msg: "Las contraseñas no coinciden, ingresa la misma contraseña en los 2 cuadros de texto por favor",
            ok: false,
          });
        }
      } else {
        setModal({
          show: true,
          msg: "Los campos no pueden estar en blanco, ingrese contraseña por favor",
          ok: false,
        });
      }
    } else {
    }
  };



  return (
    <>
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6 text-center">
        
        {step4Recupera?
              <a
              className=" w-full mt-1 px-4 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500  text-white rounded-lg"
              href="/campus/login"
            >
              Ir a Login
            </a>
        :
                  <button
                  onClick={() => {
                    if (modal.reload) {
                      window.location.reload();
                    }
                    setModal((curr) => ({
                      ...curr,
                      show: false,
                      reload: false,
                    }));
                  }}
                  type="button"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                  
                >
                  Entendido
                </button>
        }

        </div>
      </WarningModal>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ setFieldValue, values, errors, touched }) => {

          return <Form>
            {children}
            {step3Recupera ? <NuevoPassword handleContinuar={handleContinuar} handleAtras={handleAtras} datosRevisionCuenta={datosRevisionCuenta} handleClick={handleClick} /> :null}
                         
          </Form>;
        }}
      </Formik>
    </>
  );
};

export default SeleccionRecuperar;
